import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatStartMessageForm } from 'shared/components/ChatStartMessageForm';
import { useChats } from 'shared/hooks/useChats';
import { selectUser, selectOffer, selectIsOfferPublished } from 'shared/selectors';
import { offerChatSelector } from 'shared/selectors/offerChat';

import { trackStartChatWithMessageClick } from './tracking';

export function ChatStartMessageFormContainer() {
  const [value, setValue] = React.useState<string>('');
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  const { isChatsEnabled } = useSelector(offerChatSelector);
  const { handleOpenChat } = useChats();
  const user = useSelector(selectUser);
  const isOfferPublished = useSelector(selectIsOfferPublished);
  const offer = useSelector(selectOffer);

  const handleSend = React.useCallback(() => {
    if (value) {
      trackStartChatWithMessageClick(offer);
      handleOpenChat({
        defaultMessage: value,
        shouldSendDefaultMessage: true,
      });
    }
    setValue('');
    if (textareaRef.current) {
      textareaRef.current.value = '';
    }
  }, [offer, handleOpenChat, value]);

  const handleChange = React.useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value);
  }, []);

  if (!isChatsEnabled || user?.cianUserId === offer.cianUserId || !isOfferPublished) {
    return null;
  }

  return (
    <ChatStartMessageForm
      onClick={handleSend}
      onChange={handleChange}
      isDisabled={!(value.trim().length > 0)}
      inputRef={textareaRef}
    />
  );
}
